import { useApi } from "#hooks/useApi"
import { courseGet } from "#training/services/Api"
import { createContext, useContext, useMemo, useState } from "react"
const AnnualPlanCreateContext = createContext()

/**
 * @typedef {Object} collaboratorsItem
 * @property {number} count
 * @property {string} data
 */
/**
 * @typedef {Object} areaItem
 * @property {number} id - Identificador único.
 * @property {string} description - nombre del area.
 * @property {collaboratorsItem} collaborators - Año o valor relacionado.
 * @property {boolean} annual_plan - Indica si ya tiene un plan anual.
 */
/**
 * @typedef {Object} AnnualPlanContextType
 * @property {boolean} reload - Indica si se debe recargar.
 * @property {function(boolean):void} setReload - Setter para cambiar `reload`.
 * @property {Array<any>} selectAreas - Áreas seleccionadas.
 * @property {function(Array<any>):void} setSelectAreas - Setter para cambiar `selectAreas`.
 * @property {Array<any>} cursosIds - cursos seleccionadas.
 * @property {Array<any>} cursos .
 * @property {function(Array<any>):void} setCursosIds - Setter para cambiar `cursosIds`.
 * @property {areaItem[]} areas - Áreas.
 */

/**
 * Proveedor de contexto para el plan anual.
 *
 * @param {Object} props
 * @param {React.ReactNode} props.children - Componentes hijos.
 * @param {areaItem[]} props.areas - Lista de áreas.
 */
export function AnnualPlanCreateProvider({ children, areas, reload, setReload }) {
	// const [reload, setReload] = useState(true)
	const [selectAreas, setSelectAreas] = useState([])
	const [cursosIds, setCursosIds] = useState([])
	const params = useMemo(() => ({ list: true }), [])
	const { data } = useApi(courseGet, { autoFetch: !!selectAreas.length, params })
	const { cursos = [] } = data || {}
	const datos = useMemo(
		() => ({
			reload,
			setReload,
			selectAreas,
			setSelectAreas,
			areas,
			cursosIds,
			setCursosIds,
			cursos,
		}),
		[areas, cursos, cursosIds, reload, selectAreas, setReload]
	)
	return (
		<AnnualPlanCreateContext.Provider value={datos}>
			{children}
		</AnnualPlanCreateContext.Provider>
	)
}
/**
 * Hook para acceder al contexto de creación del plan anual.
 * @returns {AnnualPlanContextType}
 */
export function UsePlanAnualContext() {
	return useContext(AnnualPlanCreateContext)
}
